import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon, getUtility, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material';
import useStyles from './styles';
export default function BillFrequencyModal(_ref) {
  let propertyUtility = _ref.propertyUtility,
    disabledTrigger = _ref.disabledTrigger;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  let initValue = propertyUtility.billFrequencyType;
  const _useState = useState(propertyUtility.billFrequencyType),
    _useState2 = _slicedToArray(_useState, 2),
    localBillFrequencyType = _useState2[0],
    setLocalBillFrequencyType = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    modalState = _useState4[0],
    setModalState = _useState4[1];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getWarning = isProviderName => /*#__PURE__*/React.createElement("div", {
    className: classes.warning
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "warning",
    title: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white"
    }, t('add_new_property_flow.reminder')), isProviderName ? t('add_new_property_flow.enter_provider_name') : t('add_new_property_flow.enter_utility_name')),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    type: "warning",
    fontSize: isProviderName ? 'small' : '',
    state: "warning"
  }))));
  const modalTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalHeader
  }, /*#__PURE__*/React.createElement("span", null, getUtility(propertyUtility.utilityName).icon({
    pattern: 'gradient'
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, getUtility(propertyUtility.utilityName).title || propertyUtility.utilityName, ' ', t('add_new_property_flow.configuration')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "/ ", t('add_new_property_flow.bill_frequency')));
  const modalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, propertyUtility.provider.utilityProviderName);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      onClick: () => {
        setModalState(true);
      },
      'custom-attribute': '623-new-billing-module'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('general.edit'))),
    disabledTrigger: disabledTrigger,
    title: modalTitle,
    subTitle: modalSubTitle,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: e => {
        e === null || e === void 0 || e.preventDefault();
        initValue = localBillFrequencyType;
        // setUtilityBillFrequency(localBillFrequencyType);
        setModalState(false);
      },
      'custom-attribute': '624-new-billing-module'
    }, t('add_new_property_flow.save_and_close')),
    noLeftButton: true,
    variant: "staticHeight",
    isOpen: modalState,
    handleOpen: () => setModalState(true),
    handleClose: () => {
      setLocalBillFrequencyType(initValue);
      // setUtilityBillFrequency(initValue);
      setModalState(false);
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.bill_frequency')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: localBillFrequencyType,
    exclusive: true,
    onChange: e => {
      setLocalBillFrequencyType(e.target.value);
    },
    'custom-attribute': '625-new-billing-module'
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "Monthly",
    'custom-attribute': '626-new-billing-module-Monthly'
  }, t('general.month')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "BiMonthly",
    'custom-attribute': '626-new-billing-module-BiMonthly',
    disabled: true
  }, t('general.bi_monthly')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "Trimonthly",
    'custom-attribute': '626-new-billing-module-Trimonthly',
    disabled: true
  }, t('general.quarterly')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "Annually",
    'custom-attribute': '626-new-billing-module-Annually',
    disabled: true
  }, t('general.annually'))), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.xssSection
  }, t('add_new_property_flow.bi_monthly_available_soon'))));
}